<div style="padding: 20px;" >
<signature-pad style="display: inline-block; outline-style: groove;
    outline-color: black;
    outline-width: 2px;
    width: 700px;"
    [options]="signaturePadOptions"
    (onBeginEvent)="drawStart()"
    (onEndEvent)="drawComplete()"
    ></signature-pad>
</div>
